import { createFileRoute, redirect } from "@tanstack/react-router"
import Register from "@/pages/account/register"

export const Route = createFileRoute("/$countryCode/account/register")({
  // No sign-ups while the site's own checkout is closed (every order goes
  // through Toast): a new account could not order anything. Existing customers
  // still sign in for their order history, so send visitors to login instead.
  loader: async ({ params, context }) => {
    const { isSiteCheckoutOpen, siteSettingsQueryOptions } = await import(
      "@/lib/data/site-settings"
    )
    const siteSettings = await context.queryClient.ensureQueryData(
      siteSettingsQueryOptions
    )
    if (!isSiteCheckoutOpen(siteSettings)) {
      throw redirect({
        to: "/$countryCode/account/login",
        params: { countryCode: params.countryCode },
        statusCode: 307,
      })
    }
  },
  head: () => ({
    meta: [
      { title: "Create an account | +Bake Cafe" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: Register,
})
